<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography" [innerHTML]="data.detail">
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-default btn-sm border" mat-dialog-close>Close</button>
</mat-dialog-actions>
